import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import Loader from "@/components/base/Loader.vue";
import { IUserV3 } from "@/api/types/user";
import UserCardMain from "@/components/administration/users/UserCardMain.vue";
import UserCardMessengers from "@/components/administration/users/UserCardMessengers.vue";
import UserCardImage from "@/components/administration/users/UserCardImage.vue";
import UserCardRoles from "@/components/administration/users/UserCardRoles.vue";
import { USER_ROLES } from "@/mappings/user-roles";

interface Props {
    user: IUserV3,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserMain',
  props: {
    user: null
  },
  setup(__props: any) {

const props = __props as {
    user: IUserV3,
}

// @ts-ignore

const isLoading = ref<boolean>(false);

const isVisible = computed<boolean>(() => {
    return props.user.roles?.some((role: any) => role === USER_ROLES.EMPLOYEE)!;
});

const isUserEmpty = computed<boolean>(() => {
    return Object.keys(props.user)?.length <= 0;
});

return { __sfc: true,props, isLoading, isVisible, isUserEmpty, Loader, UserCardMain, UserCardMessengers, UserCardImage, UserCardRoles }
}

})